export const TITLE = 'Your account claim session expired';

export const DESCRIPTION =
  "Unfortunately, your account claim session expired. We've sent you a new claim email to the same email address so you can try again. If you already have an account, login in instead";
